<template>
  <button-categories></button-categories>
</template>

<script>
import api from '@/api'
import ButtonCategories from './ButtonCategories.vue'
export default {
  computed: {},
  components: {
    ButtonCategories
  },
  data: function() {
    return {}
  },
  created() {},
  mounted() {
    let vm = this
  },
  methods: {},
  watch: {}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductsTab.vue